import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { ContactType } from '@/core/domain/_shared/ContactType';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { useInvoiceHubMail } from '@/core/domain/invoiceTransmissionHub/Invoice/Invoice.hooks';
import { useMailInvoiceNfs } from '@/core/domain/nfs/NfseController/NfseController.hooks';
import { useCustomerContacts } from '@/core/domain/people/CustomerContacts/CustomerContacts.hooks';
import { useInsurerContactList } from '@/core/domain/people/InsurerContact/InsurersContact.hooks';
import { useSupplierContacts } from '@/core/domain/people/SupplierContact/SupplierContact.hook';
import { useDisclosure } from '@/hooks';
import { AutoComplete, Button, Modal, message } from 'antd';
import { useState } from 'react';

interface Props {
  type: InvoiceType;
}

export default function SendEmailInternalButton({ type }: Props) {
  const { invoice } = useInvoiceFormContext();

  const customerContacts = useCustomerContacts(
    invoice.data?.customerId,
    !!invoice.data?.customerId,
  );
  const insurerContacts = useInsurerContactList(invoice.data?.insurerId);
  const supplierContacts = useSupplierContacts(invoice.data?.supplierId);

  const customerEmails = customerContacts.data?.flatMap((detail) =>
    detail.detailList
      .filter((contact) => contact.contactType === ContactType.Email)
      .map((contact) => contact.value),
  );

  const insurerEmails = insurerContacts.data?.flatMap((detail) =>
    detail.detailList
      .filter((contact) => contact.contactType === ContactType.Email)
      .map((contact) => contact.value),
  );

  const supplierEmails = supplierContacts.data?.flatMap((detail) =>
    detail.detailList
      .filter((contact) => contact.contactType === ContactType.Email)
      .map((contact) => contact.value),
  );

  const emailList = customerEmails || insurerEmails || supplierEmails;

  const [email, setEmail] = useState<string>();

  const invoiceHubMail = useInvoiceHubMail();
  const mailInvoiceNfs = useMailInvoiceNfs();

  const [opened, action] = useDisclosure(false);

  async function handleSubmit() {
    if (email) {
      type === InvoiceType.NFS
        ? await mailInvoiceNfs.mutateAsync({
            email: email,
            invoiceId: Number(invoice?.data?.id),
          })
        : await invoiceHubMail.mutateAsync({
            email: email,
            invoiceId: Number(invoice?.data?.id),
            type,
          });
      action.close();
    } else {
      message.warn('Informe um e-mail');
    }
  }

  const loading = invoiceHubMail.isLoading || mailInvoiceNfs.isLoading;

  return (
    <>
      {loading && (
        <ModalLoadingOverlay
          messages={['Enviando nota...', 'Validando dados da nota...']}
        />
      )}

      <Button type="primary" onClick={action.open} block>
        Enviar E-mail
      </Button>

      <Modal
        title="Enviar nota fiscal por e-mail"
        okText="Enviar"
        open={opened}
        onCancel={() => {
          setEmail(undefined);
          action.close();
        }}
        onOk={handleSubmit}
        confirmLoading={invoiceHubMail.isLoading}
      >
        <div>
          <p>Confirme o e-mail de envio do destinatário</p>

          <AutoComplete
            disabled={invoiceHubMail.isLoading}
            options={emailList?.map((value) => ({ value }))}
            placeholder="E-mail"
            value={email}
            onChange={(value) => setEmail(value)}
            searchValue={email}
            onSearch={(value) => setEmail(value)}
            style={{ width: '100%' }}
          />
        </div>
      </Modal>
    </>
  );
}
